import type { ReactNode } from "react";

interface NoticeProps {
  children: ReactNode;
  className?: string;
}

export function Notice({ children, className = "" }: NoticeProps) {
  return <div className={["edlab-notice", className].join(" ")}>{children}</div>;
}
